<template>
    <div>
          <!-- v-model="selectData.userId" -->
        <el-select
            v-if="multiple"
            v-model="selectUsers"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入关键词"
            :multiple="true"
            :remote-method="queryUserList"
            :loading="loading" 
            @change="selectTrigger">
            <el-option
                v-for="item in userList"
                :key="item.userId"
                :label="item.trueName"
                :value="item.userId">
            </el-option>
        </el-select>

        <el-select
            v-else
            v-model="selectName"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="queryUserList"
            :loading="loading" 
            @change="selectTrigger">
            <el-option
                v-for="item in userList"
                :key="item.userId"
                :label="item.trueName"
                :value="item.userId">
            </el-option>
        </el-select>
    </div>
</template>

<script>
    import { getUserList } from '@/data-model';
    // import { isEmpty } from 'lodash';

    export default {
        data () {
            return {
                loading: false,
                userList: [],
                selectUsers: [],
                mutilUsers: '',
                selected: {
                    userId: '',
                    trueName: ''
                },
                selectName: ''
            };
        },
        computed: {
            // selectUsers: {
            //     get () {
            //         if (isEmpty(this.mutilUsers)) {
            //             return [];
            //         }
            //         return this.mutilUsers.split(',');
            //     },
            //     set (newVal, oldVal) {
            //         this.mutilUsers = newVal.join(',');
            //         this.formData[this.field.formField] = newVal.join(',');
            //     }
            // }
        },
        props: {
            field: {
                type: Object,
                required: true
            },
            formData: {
                type: Object,
                required: true
            },
            multiple: {
                type: Boolean,
                required: false
            }
        },
        created () {
            // this._setDefaultUser();
            this.queryUserList('');
            this._initUsers();
        },
        methods: {
            async _initUsers () {
                this._setDefaultUser('');
            },
            _setDefaultUser (selectedUser) {
                if (selectedUser && !this.multiple) {
                    this.selectName = selectedUser.trueName;
                    this.formData[this.field.formField] = selectedUser.userId;
                    this.formData[this.field.formField + '-user'] = selectedUser.trueName;
                } else if (selectedUser && this.multiple) {
                    this.selectUsers = selectedUser.split(',');
                }
            },
            async queryUserList (userName) {
                this.loading = true;
                let userData = await getUserList({ name: userName });
                this.userList = userData.data;
                this.loading = false;
            },
            selectTrigger (val) {
                if (this.multiple) {
                    if (this.formData) {
                        if (val) {
                            let names = [];
                            this.userList.find((item) => {
                                val.find((it) => {
                                    if (item.userId === it) {
                                        names.push(item.trueName);
                                    }
                                });
                            });
                            this.formData[this.field.formField] = val.join(',');
                            this.formData[this.field.formField + '-user'] = names.join(',');
                        } else {
                            this.userList = [];
                            this.formData[this.field.formField] = '';
                            this.formData[this.field.formField + '-user'] = '';
                        }
                        // console.log(this.formData[this.field.formField]);
                        // console.log(this.formData[this.field.formField + '-user']);
                    }
                } else {
                    if (val) {
                        this.selected = this.userList.find((item) => {
                            return item.userId === val;
                        });
                    } else {
                        this.selected = {userId: '', trueName: ''};
                    }
                    if (this.formData) {
                        this.formData[this.field.formField] = this.selected.userId;
                        this.formData[this.field.formField + '-user'] = this.selected.trueName;
                    }
                }
                this.$emit('nodeClick', {id: this.selected.userId, label: this.selected.trueName});
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/User/User.vue